<script lang="ts">
  import clsx from 'clsx';
  import { TextLink } from '@athena-lib/TextLink';
  import type { BreadcrumbsProps } from './types';

  const { breadcrumbs, linkClass }: BreadcrumbsProps = $props();

  const breadcrumbClasses = 'min-w-0 text-nowrap px-gutter';
</script>

<nav aria-label="Breadcrumbs" class="bg-st-gray-100">
  <ol class="-mx-gutter line-clamp-1 flex">
    {#each breadcrumbs as breadcrumb (breadcrumb.linkUrl + breadcrumb.name)}
      <li
        class={clsx(
          breadcrumb !== breadcrumbs[0] && "truncate before:text-st-gray-600 before:content-['/']",
        )}
      >
        {#if breadcrumb === breadcrumbs[breadcrumbs.length - 1]}
          <span class={clsx(breadcrumbClasses)}>{breadcrumb.name}</span>
        {:else}
          <TextLink href={breadcrumb.linkUrl} class={clsx(breadcrumbClasses, linkClass)}>
            {breadcrumb.name}
          </TextLink>
        {/if}
      </li>
    {/each}
  </ol>
</nav>
